import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Moon, Sun } from "lucide-react"; // Optional: install with `npm install lucide-react`

const ThemeToggle = () => {
    const [theme, setTheme] = useState("light");

    // Load saved theme from localStorage
    useEffect(() => {
        const savedTheme = localStorage.getItem("theme") || "light";
        setTheme(savedTheme);
        document.documentElement.classList.toggle("dark", savedTheme === "dark");
    }, []);

    const toggleTheme = () => {
        const newTheme = theme === "light" ? "dark" : "light";
        document.documentElement.classList.toggle("dark", newTheme === "dark");
        setTheme(newTheme);
        localStorage.setItem("theme", newTheme);
    };

    return (
        <li className="list-none">
            <button
                onClick={toggleTheme}
                className="flex items-center justify-center  bg-gradient-to-r from-blue-500 to-orange-800 text-white py-2 px-3 rounded-md hover:opacity-90 transition-opacity"
            >
                {theme === "light" ? (
                    <>
                        <Moon size={16} />
                        <span>DarkMode</span>
                    </>
                ) : (
                    <>
                        <Sun size={16} />
                        <span>LightMode</span>
                    </>
                )}
            </button>

        </li>
    );
};

export default ThemeToggle;
